'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryAddress = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(DeliveryAddress, _React$PureComponent);

    function DeliveryAddress() {
        (0, _classCallCheck3.default)(this, DeliveryAddress);
        return (0, _possibleConstructorReturn3.default)(this, (DeliveryAddress.__proto__ || (0, _getPrototypeOf2.default)(DeliveryAddress)).apply(this, arguments));
    }

    (0, _createClass3.default)(DeliveryAddress, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                name = _props.name,
                companyName = _props.companyName,
                contactPerson = _props.contactPerson,
                street = _props.street,
                city = _props.city,
                postCode = _props.postCode,
                countryName = _props.countryName,
                selected = _props.selected,
                onChange = _props.onChange,
                readOnly = _props.readOnly;

            var firstLine = [companyName, contactPerson].filter(function (x) {
                return x;
            });
            var lastLine = [city, postCode, countryName].filter(function (x) {
                return x;
            });
            var htmlId = 'diff-delivery--' + id;
            var className = "delivery__box";
            if (readOnly) {
                className = className + " readonly";
            }
            return _react2.default.createElement(
                'div',
                { className: className },
                !readOnly && _react2.default.createElement('input', { type: 'radio', name: 'diff-delivery', checked: !readOnly && selected, onChange: onChange, id: htmlId }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: htmlId },
                    _react2.default.createElement(
                        'strong',
                        null,
                        name
                    ),
                    (0, _intersperse2.default)(firstLine.map(function (x, i) {
                        return _react2.default.createElement(
                            'span',
                            { key: i },
                            x
                        );
                    }), ', '),
                    firstLine.length > 0 && _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'span',
                        null,
                        street
                    ),
                    _react2.default.createElement('br', null),
                    (0, _intersperse2.default)(lastLine.map(function (x, i) {
                        return _react2.default.createElement(
                            'span',
                            { key: i },
                            x
                        );
                    }), ', ')
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'delivery-box__edit', onClick: this.props.onEditClick },
                    _react2.default.createElement('i', { className: 'icon--pen' })
                )
            );
        }
    }]);
    return DeliveryAddress;
}(_react2.default.PureComponent), _class.propTypes = {
    selected: _propTypes2.default.bool.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    id: _propTypes2.default.number,
    name: _propTypes2.default.string,
    street: _propTypes2.default.string,
    postCode: _propTypes2.default.string,
    city: _propTypes2.default.string,
    countryName: _propTypes2.default.string,
    onEditClick: _propTypes2.default.func,
    readOnly: _propTypes2.default.bool
}, _temp);
exports.default = DeliveryAddress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/DeliveryAddress.js
// module id = 1032
// module chunks = 0